module.exports = __webpack_public_path__ + "static/media/tomatos.398eaf9e.png";